"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const WindowPopup = (_a) => {
    var { url, children, onClose } = _a, restProps = __rest(_a, ["url", "children", "onClose"]);
    const [root, setRoot] = (0, react_1.useState)(null);
    const windowToOpen = (0, react_1.useRef)(null);
    const timerId = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        const div = document.createElement('div');
        setRoot(div);
        timerId.current = window.setInterval(() => {
            var _a;
            if ((_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.closed) {
                window.clearInterval(timerId.current);
                if (onClose)
                    onClose();
            }
        }, 1000);
        return () => {
            window.clearInterval(timerId.current);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!root) {
            return;
        }
        const width = restProps.width || Math.max(640, window.innerWidth / 3);
        const height = restProps.height || Math.max(640, window.innerHeight / 3);
        const left = restProps.left || Math.max(0, window.innerWidth / 2 - width / 2);
        const top = restProps.top || Math.max(0, window.innerHeight / 2 - height / 2);
        windowToOpen.current = window.open(url, '_blank', `popup=true,width=${width},height=${height},top=${top},left=${left}`);
        (_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.document.body.appendChild(root);
        return () => { var _a; return (_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.close(); };
    }, [root]);
    return root && (0, react_dom_1.createPortal)(children, root);
};
exports.default = WindowPopup;
